<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibles"
      width="25%"
    :before-close="handleClose"
    >
      <div class="bodys">
        <div class="body_div">
          <img src="@/assets/home/login.png" alt="" width="100%" />
        </div>
        <div class="body_from">
          <div class="froms">
            <div class="from1">用户名</div>
            <div class="from2"><el-input></el-input></div>
          </div>
          <div class="froms">
            <div class="from1">密码</div>
            <div class="from2"><el-input></el-input></div>
          </div>
          <div class="froms1">
            <div class="from1">验证码</div>
            <div class="from2"><el-input></el-input></div>
            <div></div>
          </div>
                <div style="margin-top:40px" class="btn">
             <el-button style="width:90%;" type="primary" round @click="handleClose">立即登录</el-button>
             </div>
        </div>
        
        
        <!-- <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
    props:{
         dialogVisibles: {
      type: Boolean,
      
    },
    },
  data() {
      
    return {

    };
  },
  methods: {
   handleClose(){
    this.$emit('closepop');
   }
  },
};
</script>

<style lang="scss" scoped>
.bodys {
  width: 100%;
  height: 450px;
  .body_div {
    width: 100%;
    height: 40%;
  }
  .body_from {
    width: 100%;
    height: 60%;

    .froms {
      display: grid;
      grid-template-columns: 1fr 4fr;
      margin-top: 20px;

      .from1 {
        display: grid;
        justify-items: center;
        align-items: end;
      }
      .from2 {
        padding-right: 20px;
      }
    }
    .froms1{
          display: grid;
      grid-template-columns: 1fr 3fr 1fr;
      margin-top: 20px;

      .from1 {
        display: grid;
        justify-items: center;
        align-items: end;
      }
      .from2 {
        padding-right: 20px;
      }
    }
  }
}
.btn{
   display: grid;
   place-items: center;  
}
::v-deep.el-dialog__header {
  display: none;
}
::v-deep.el-input__inner {
  border: none;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0px;
}
::v-deep.el-dialog__body {
  padding: 0;
}
</style>
